module.exports = __webpack_public_path__ + "static/media/ExpertKnowledge.18c6a607.png";